// Hücre editörü + hücre tarihçesi kopyası — `KPI_COPY.cell` / `KPI_COPY.cellHistory` olarak açılır
// (kpi-ui.ts 600 satır kuralı, TODO-KPI-114/-158: salt taşıma).

import { type KpiChangeKind } from "@mahir/shared";
import { formatUnitFactor } from "./kpi-unit-options";

export const KPI_CELL_COPY = {
  pending: "XXX",
  /** Finar 17 — hücre editörü durum seçeneği (yer tutucu; hücrede yine XXX görünür) */
  pendingOption: "Değer bekleniyor (XXX)",
  /** Özet karşılaştırma tablosu durum hapı (yer tutucu) */
  pendingPill: "DEĞER BEKLENİYOR",
  dash: "-",
  calcError: "HESAPLANAMADI",
  notMeasured: "Ölçülmüyor",
  /** M17 — onaylı değeri değiştirirken neden (yalnız iç aktör; raporda "Düzeltmeler" dipnotu) */
  changeReason: "Değişiklik nedeni",
  changeReasonHint: "İsteğe bağlı — raporda düzeltme dipnotu olur",
  /** K8 (Finar) — kısmi toplam (†) hücresinde ⓘ düğmesi + PartialInfoPopover / FormulaPopover */
  partialInfo: "Kısmi toplam — ayrıntı",
  partialTitle: "Kısmi toplam",
  partialRefs: "Ölçülmeyen kalemler (toplama dahil değil)",
  partialEntities: "Ölçülmeyen işletmeler",
  partialPending: "Bazı girdiler XXX ya da boş",
  allUnmeasuredReason: "tüm kalemler ölçülmüyor",
  /** TODO-KPI-91 — AGIRLIKLI_ORT kalemleri sırayla eşlenir; popover gerekçesi + eşleme bloğu */
  wavgMismatchReason: "alt kalem sayıları eşit değil",
  wavgEmptyReason: "alt kalem yok",
  wavgPairsTitle: "Eşleme (kalemler sırayla eşlenir)",
  /** K6 — önceki yıla göre 10× dışı değer (bloklamaz; Değer sekmesinde amber satır) */
  outlier: (prior: string, value: string, ratio: string): string =>
    `Önceki yıl ${prior}, bu değer ${value} (${ratio}) — olağan dışı görünüyor, kontrol edin.`,
  /** Finar rev-B 3 — formüllü hücre hover kartı (danışman; portal karşılığı KPI_COPY.portal.hover) */
  hover: {
    formula: "Formül",
    noFormula: "Aktif formül yok — veri seti editöründen bir varyant seçin.",
    more: "Girdiler ve ayrıntı için hücreye tıklayın.",
  },
} as const;

/** M17 — hücre "Geçmiş" sekmesindeki sürüm listesi (yalnız iç aktör; portalda liste yok) */
export const KPI_CELL_HISTORY_COPY = {
  title: "Sürümler",
  loading: "Sürümler yükleniyor…",
  error: "Sürümler yüklenemedi",
  retry: "Yeniden dene",
  empty: "Henüz sürüm yok",
  more: (n: number): string => `+${n.toString()} önceki sürüm`,
  showAll: "Tümünü göster",
  current: "(güncel)",
  reason: "Neden:",
  /** Sürümün yazıldığı birim kaydı yok (eski sürüm). */
  noUnit: "birim bilgisi yok",
  /** Birim değişimi olay satırı (DR14): çevrimde sayı + çarpan, relabel'de yalnız etiket. */
  unitEvent: (
    from: string | null,
    to: string | null,
    count: number,
    factor: number | null,
    mode: "convert" | "relabel",
  ): string => {
    const head = `Birim ${from ?? "—"} → ${to ?? "—"}`;
    if (mode === "relabel") return `${head} · yalnız etiket düzeltildi`;
    // M4 — Türkçe, 4 anlamlı basamak (GJ→MWh "×0,2778", ham "×0,2777777777777778" değil)
    const f = factor === null ? "" : ` (${formatUnitFactor(factor)})`;
    return `${head} · ${count.toString()} değer çevrildi${f}`;
  },
  events: {
    write: "değer girildi",
    verify: "onaylandı",
    clarify: "açıklama istendi",
    pin: "sabitlendi",
    approve: "şirket onayladı",
    import: "içe aktarıldı",
    move: "taşındı",
    reported: "raporlanan değer",
    evidence: "kanıt bağlandı",
    unit_change: "birim değişimi",
  } satisfies Record<KpiChangeKind, string>,
} as const;
